import React, { useEffect } from "react";
import { MdNavigateNext, MdNavigateBefore, MdClose } from "react-icons/md";
import CircleButton from "../../../Button/CircleButton";

import Container from "./styles";

const Lightbox = ({ photos, isVisible, currentPhotoId, setShowLightbox, setCurrentPhotoId }) => {
    const ids = photos.map(value => value.id);

    const toggleLightbox = () => {
        const scrollY = window.scrollY;
        if (isVisible) {
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollY}px`;
        } else {
            const top = document.body.style.top;
            document.body.style.position = "";
            document.body.style.top = "";
            window.scrollTo(0, parseInt(top || "0") * -1);
        }
    };

    const getKey = () => {
        return ids.indexOf(currentPhotoId);
    };

    const prev = () => {
        setCurrentPhotoId(ids[getKey(currentPhotoId) - 1]);
    };

    const next = () => {
        setCurrentPhotoId(ids[getKey(currentPhotoId) + 1]);
    };

    useEffect(() => {
        window.addEventListener("scroll", () => {
            document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
        });
        toggleLightbox();
    }, []);

    return photos[getKey(currentPhotoId)] ? (
        <Container className={isVisible ? "open" : null}>
            <div className="content">
                <div className="backdrop" onClick={() => setShowLightbox(false)}></div>
                <div className="prev">
                    {getKey(currentPhotoId) > 0 && (
                        <CircleButton onClick={prev}>
                            <MdNavigateBefore size={16} />
                        </CircleButton>
                    )}
                </div>
                <div className="media">
                    <div className="close">
                        <CircleButton onClick={() => setShowLightbox(false)} dark="true">
                            <MdClose size={16} />
                        </CircleButton>
                    </div>
                    {photos[getKey(currentPhotoId)].type === "video" ? (
                        <video controls>
                            <source src={photos[getKey(currentPhotoId)].thumb} type="video/mp4" />
                        </video>
                    ) : (
                        <img src={photos[getKey(currentPhotoId)].thumb} />
                    )}
                    <p className="filename">{decodeURIComponent(photos[getKey(currentPhotoId)].originalFilename)}</p>
                </div>
                <div className="next">
                    {getKey(currentPhotoId) + 1 < ids.length && (
                        <CircleButton onClick={next}>
                            <MdNavigateNext size={16} />
                        </CircleButton>
                    )}
                </div>
                <div className="mobile">
                    <p className="filename">{photos[getKey(currentPhotoId)].originalFilename}</p>
                    <div>
                        {getKey(currentPhotoId) > 0 && (
                            <CircleButton onClick={prev}>
                                <MdNavigateBefore size={16} />
                            </CircleButton>
                        )}
                        {getKey(currentPhotoId) + 1 < ids.length && (
                            <CircleButton onClick={next}>
                                <MdNavigateNext size={16} />
                            </CircleButton>
                        )}
                    </div>
                </div>
            </div>
        </Container>
    ) : null;
};

export default Lightbox;
